import { useFormikContext } from 'formik'
import { useState } from 'react'

import { useTranslation } from 'next-i18next'

import ErrorMessage from 'components/ErrorMessage/ErrorMessage'
import Field from 'components/Form/Field/Field'
import Form from 'components/Form/Form'
import Password from 'components/Form/Password/Password'
import Select from 'components/Form/Select/Select'
import Link from 'components/Link'
import SubmitButton from 'components/SubmitButton'
// import ValidationPointsList from 'components/ValidationPoint/ValidationPointsList'

import styles from './RegisterForm.module.scss'

interface IRegisterFormValues {
  email: string
  password: string
  currency: string
}
const RegisterFormInner = ({
  currencies,
  isCurrenciesloading,
  error,
  isLoading,
  isSucceed,
  referrer,
}) => {
  const { values } = useFormikContext<IRegisterFormValues>()
  const [t] = useTranslation(['main', 'error'])

  const [isPointsVisible, toggleIsPointsVisible] = useState(false)

  return (
    <Form autoComplete="off">
      <Field
        name="email"
        type="email"
        placeholder={t('main:authEnterEmail')}
        id="registration-form-field-input"
      />
      <Password
        referrer={referrer}
        name="password"
        placeholder={t('main:authEnterPassword')}
        onFocus={() => toggleIsPointsVisible(true)}
        id="registration-form-password-input"
      />
      {/* {isPointsVisible && <ValidationPointsList t={t} password={values.password} />} */}
      <Select
        options={currencies}
        isLoading={isCurrenciesloading}
        name="currency"
        placeholder={t('main:signUpCurrency')}
        id="registration-form-currency-input"
        optionId="registration-form-currency"
      />
      {error && <ErrorMessage icon={error.icon} message={error.message} />}
      <div className={styles.submit}>
        <SubmitButton
          id="registration-form-submit-button"
          isLoading={isLoading}
          isSucceed={isSucceed}
        >
          {t('main:signUpCreateAcc').toString()}
        </SubmitButton>
        <div className={styles.register}>
          <span>{t('main:signUpAlreadyHaveAcc')}</span>
          <Link href="/auth/signin" as="/auth/signin" id="registration-form-signin-anchor">
            {t('main:signUpLoginWitnSpace')}
          </Link>
        </div>
      </div>
      <div className={styles.additional}>
        {`${t('main:signUpConfirmSignUpFirst')} `}
        <Link
          href="/regulation/terms-and-conditions"
          className={styles.link}
          target="_blank"
          id="registration-form-terms-link"
        >
          {t('main:signUpConfirmSignUpSecond')}
        </Link>
        {`${t('main:signUpConfirmSignUpThird')} `}
        <Link
          href="/regulation/privacy-policy"
          className={styles.link}
          target="_blank"
          id="registration-form-privacy-link"
        >
          {t('main:signUpConfirmSignUpFouth')}
        </Link>
      </div>
    </Form>
  )
}

export default RegisterFormInner
